<template>
  <div class="text-dark mx-auto">
    <div class="flex flex-col items-center my-10 text-center" style="font-size: 26px">
      <span v-if="substep == 'build'">
        {{ $t('frontend_groovemail_edit_form_route_page_title') }}
      </span>
      <span v-else>
      {{ $t('frontend_groovemail_design_form_route_page_title') }}
      </span>
    </div>
    <groovemail-form-variants 
      v-if="localModel"
      :model='localModel'
      :substep="substep"
    />
  </div>
</template>

<script>
import GroovemailFormVariants from '@/components/GrooveMailFormVariants.vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import themeConfig from '@/theme/themeConfig.js';


export default {
  name: 'Step1',

  props: {
    substep: {
      required: true,
    },
    model: {
      required: true,
    },
  },

  data() {
    return {
      changesMadeInStep: false,
      localModel: this.model,
      fullPageLoader: true,
      loaderColor: themeConfig.appPrimaryColor,
      standardFieldIdentifiers: [
        'email',
        'first_name',
        'last_name',
        'address_1',
        'company',
        'phone_number',
        'state',
        'country',
        'zip',
        'url',
      ],
    };
  },

  watch: {
    localModel() {
      this.$emit('updateModel', this.localModel);
    },

    'localModel.form_fields': function wtachFormFields() {
      this.changesMadeInStep = true;
    },

    'localModel.form_heading': function wtachFormheading() {
      this.changesMadeInStep = true;
    },

    'localModel.form_sub_heading': function wtachFormSubHeading() {
      this.changesMadeInStep = true;
    },
  },

  methods: {
    checkChangesMadeOnThisStep() {
      return this.changesMadeInStep;
    },
    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },

    validateForSaveAndExit() {
      return true;
    },

    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader() {
      this.$emit('hideLoader');
    },
  },

  components: {
    GroovemailFormVariants,
  },
};
</script>
<style lang="scss">
.identifier-error {
  top: 65px;
}
.form-content-box {
  box-shadow: 10px 25px 40px 0 rgba(22, 29, 37, 0.05);
  border-radius: 6px;
  background: #fff;
}
.add-new-field-popup,
.add-new-custom-field-popup,
.edit-standard-field-popup,
.edit-custom-field-popup {
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 4px 20px 0 rgba(22, 29, 37, 0.1);
  z-index: 99;
  top: 51px;
}
.add-new-custom-field-popup {
  top: auto;
  bottom: -90px;
  width: 28rem;
  left: -25px;
}
.edit-custom-field-popup {
  top: 51px;
}

.custom-treeselect.disabled-treeselect {
  .vue-treeselect__control {
    background: #a4a8c0 ;
  }
}

.form-builder-wrapper {
  /* The container */
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    line-height: 24px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  // ----------------------------- //
  .radio-container {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    line-height: 24px;
  }
}

.custom-multilevel-select {
  .vue-treeselect__control {
    .vue-treeselect__input-container,
    .vue-treeselect__single-value {
      padding: 0;
      font-size: 14px;
    }
  }
  .vue-treeselect__menu > .vue-treeselect__list {
    max-height: 230px;
    padding: 0 0 12px;
    .vue-treeselect__option {
      padding: 12px 24px 0;
    }
    & > .vue-treeselect__list-item:last-child {
      width: 100%;
      padding: 0;
      border: none;
      & > .vue-treeselect__option {
        display: none;
      }
      .vue-treeselect__option-arrow-placeholder {
        display: none;
      }
    }
    .vue-treeselect__list {
      max-height: inherit;
      overflow: visible;
      padding: 0;
      .vue-treeselect__option {
        padding: 3px 24px;
      }
    }
  }
  .vue-treeselect__option--disabled
    .vue-treeselect__label-container
    .vue-treeselect__label {
    text-transform: capitalize;
    color: rgba(0, 0, 0, 0.25);
  }
}
.custom-field-options {
  & > .flex:nth-child(even) {
    background: #f8f8fc;
  }
}

.toggle-form-headers {
  right: -24px;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4!important;
}
</style>

